<template>
  <div
    v-if="role.crewInfo"
    class="vx-card crew-assignment-card"
    :class="{
      'crew-assignment-card-normal': !hasCaution && !hasWarning,
      'crew-assignment-card-caution': hasCaution,
      'crew-assignment-card-warning': hasWarning,
    }"
  >
    <div class="vx-card-header">
      <span class="vx-card-title">{{ roleName }}</span>
      <div class="info-icon-container">
        <vx-tooltip-with-slot-text position="bottom">
          <!-- ホバー時に表示するツールチップ -->
          <template v-slot:text>
            <tooltip-crew-assignment-alert :alerts="crewErrors" />
          </template>
          <!-- ホバー対象 -->
          <template v-slot:inner>
            <span
              class="material-icons crew-assignment-icon cursor-pointer"
              v-if="hasWarning || hasCaution"
              :class="{
                warning: hasWarning,
                caution: hasCaution,
              }"
            >
              error
            </span>
          </template>
        </vx-tooltip-with-slot-text>
      </div>
    </div>
    <div class="vx-card-body">
      <div class="crew-assignment-name">
        {{ crewName }}
      </div>
      <div class="crew-assignment-status">
        <span class="crew-assignment-info">{{ info }}</span>
        <span class="crew-assignment-until">{{ until }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import { TooltipCrewAssignmentAlert } from "./tooltips";
import moment from "moment";

export default {
  name: "CrewAssignmentCard",
  components: {
    VxTooltipWithSlotText,
    TooltipCrewAssignmentAlert,
  },
  props: {
    role: {
      type: Object,
      required: true,
    },
    crewErrors: {
      type: Array,
      default: () => [],
    },
    nowDate: {
      type: Date,
      default: () => new Date(),
    },
  },
  computed: {
    roleName() {
      return (this.role && this.role.name) || "";
    },
    crewName() {
      return (
        (this.role &&
          this.role.crewInfo &&
          this.role.crewInfo.crew &&
          this.role.crewInfo.crew.name) ||
        ""
      );
    },
    endAt() {
      return (
        (this.role &&
          this.role.crewInfo &&
          this.role.crewInfo.current_manning_vessel_crew &&
          this.role.crewInfo.current_manning_vessel_crew.end_at) ||
        ""
      );
    },
    info() {
      let days = "-";

      if (
        this.role &&
        this.role.crewInfo &&
        this.role.crewInfo.current_manning_vessel_crew &&
        this.role.crewInfo.current_manning_vessel_crew.start_at
      ) {
        const startAt = moment(
          new Date(this.role.crewInfo.current_manning_vessel_crew.start_at)
        );
        days = moment(this.nowDate).diff(startAt, "days", false);
      }

      return `${days}日乗船中`;
    },
    until() {
      const date = new Date(this.endAt);
      const options = { month: "numeric", day: "numeric" };
      const formatted = date.toLocaleDateString("ja-JP", options);
      return `〜${formatted}`;
    },
    hasCaution() {
      return this.crewErrors.some(alert => alert.alert_type === "CAUTION");
    },
    hasWarning() {
      return this.crewErrors.some(alert => alert.alert_type === "WARNING");
    },
  },
};
</script>

<style lang="scss" scoped>
.crew-assignment-card-normal {
  background-color: #f6f7f9;
}
.crew-assignment-card-warning {
  background-color: #fbeded;
}
.crew-assignment-card-caution {
  background-color: #fff8e4;
}
.crew-assignment-card {
  width: 150px;
  padding: 6px 10px 6px 10px;
  .vx-card-header {
    position: relative;
    .vx-card-title {
      font-size: 14px;
      line-height: 16px;
    }
    .info-icon-container {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .crew-assignment-icon {
      font-size: 16px;
      &.warning {
        color: #e02e22;
      }
      &.caution {
        color: #ffd400;
      }
    }
  }
  .vx-card-body {
    .crew-assignment-name {
      font-size: 12px;
      line-height: 16px;
      margin-top: 2px;
    }
    .crew-assignment-status {
      font-size: 10px;
      margin-top: 2px;
      line-height: 12px;
      display: flex;
      .crew-assignment-status-item {
        flex: 1;
      }
      .crew-assignment-info {
        flex: 1;
      }
      .crew-assignment-until {
        flex: 1;
        text-align: right;
      }
    }
  }
}
</style>
